import { ProjectRecords } from '~/features/projects/components/ProjectRecords'

export function ProjectRecordsPage() {
  return <ProjectRecords />
}
